'use client'

import React, { useCallback, useMemo } from 'react'
import BackButton from '@components/BackButton'
import { Box, Typography, styled } from '@mui/material'
import { usePathname, useRouter } from 'next/navigation'
import VerticalDivider from '@components/VerticalDivider'
import Badge, { BadgeStatus } from '@components/Badge'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import { ProposalDraft } from '@prisma/client'
import ProposalNavBarActions from './ProposalNavBarActions'
import { useSolana } from '@dewicats/connect-button'
import { useProposal } from '@helium/modular-governance-hooks'
import { PublicKey } from '@solana/web3.js'
import { solAddressIsValid } from '@utils/solanaUtils'
import { differenceInMinutes, isPast } from 'date-fns'

const MainBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginInlineStart: theme.spacing(2),
  flexDirection: 'row',
  height: '100%',
  alignItems: 'center',
}))

const ProposalTitle = styled(Typography)(({ theme }) => ({
  fontSize: 'var(--dewi_font_size_4)',
  textOverflow: 'ellipsis',
  '-webkit-line-clamp': 1 /* number of lines to show */,
  lineClamp: 1,
  marginInlineEnd: theme.spacing(2),
}))

const HoldingsNavBar = () => {
  const router = useRouter()
  const pathname = usePathname()

  const handleOnBack = useCallback(() => {
    router.replace(pathname.split('?').shift())
  }, [router])

  return (
    <MainBox>
      <BackButton onClick={handleOnBack} />
    </MainBox>
  )
}

export default HoldingsNavBar
